import {mix} from 'polished';
import {DefaultTheme} from 'styled-components';
import {black, cod, gallery, white} from '../colors';

import {Theme as NewsTheme} from './news';

export const ThemeAlternative: DefaultTheme = {
    ...NewsTheme,
    color: {
        primary: cod,
        secondary: white,
        foreground: white,
        background: black,
        breadcrumb: mix(0.265, cod, gallery),
        publishDate: mix(0.5, white, black)
    },
    font: {
        ...NewsTheme.font,
        weight: {
            normal: 400
        }
    }
};
